module.exports = __webpack_public_path__ + "static/media/background-night.3d4ed75a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/res/background-night.png
 ** module id = 178
 ** module chunks = 0
 **/